import { ReactElement } from 'react';

import { ReservationPreference, WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { createSingleInterpolatedTranslationKey, Translate, useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { mapPatientAvailabilityToNote } from './confirmReservation.utils';

export const useNote = (
   note: string | undefined,
   patientAvailability: WaitlistEntry['patientAvailability'],
   reservationPreference: ReservationPreference
): ReactElement => {
   const translate = useTranslate();
   const priorityLabel = translate(translationKeys.reservationPreferenceMap[reservationPreference]);

   const priorityNotePart = translate(
      createSingleInterpolatedTranslationKey(translationKeys.priorityLabelled, 'label', priorityLabel)
   );

   if (!note) {
      return (
         <span>
            {mapPatientAvailabilityToNote(patientAvailability, translate)}
            {priorityNotePart}
         </span>
      );
   }

   return (
      <>
         <span>{note}</span>
         <span>
            <span>
               <Translate>{translationKeys.datePreferences}</Translate>
               {mapPatientAvailabilityToNote(patientAvailability, translate)}
            </span>
            {priorityNotePart}
         </span>
      </>
   );
};
